import { lazy } from 'react';

export const SettingsOrdersDeliveryAsync = lazy(
    () => import('./SettingsOrdersDelivery'),
);
